import { SharedLinksApiService } from '@alfresco/adf-content-services';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WkSharedLinksApiService {
  get error(): Subject<{ statusCode: number; message: string }> {
    return this.sharedLinksApiService.error;
  }
  constructor(private readonly sharedLinksApiService: SharedLinksApiService) {}
}
